import React from 'react';
import PropTypes from 'prop-types';

import { FieldWrapper } from './css';
import formFieldOperationOptions from '../utils/formFieldOperationOptions';
import Note from '../note';

const FieldFile = ({ data }) => {
  const {
    ref,
    name,
    label,
    required,
    onChange,
    note,
    value,
    noteAppearsBelowField,
    isShowNoteBackground
  } = data;

  const renderNotes = () => {
    return (
      note &&
      note.content && (
        <Note
          type="richText"
          options={formFieldOperationOptions(value)}
          data={note}
          isShowNoteBackground={isShowNoteBackground}
        />
      )
    );
  };

  return (
    <FieldWrapper>
      <div>
        <span className="frg-body-font-14px">
          {label}
          {required && `*`}
        </span>
        {note && note.content && !noteAppearsBelowField && renderNotes()}
      </div>
      <input
        ref={ref}
        type="file"
        name={name}
        onChange={onChange}
        accept="application/msword, application/pdf, image/jpeg, image/png"
      />
      {name === 'documentFMSOW' && <p>Currently Uploading File: {value}</p>}
      {note && note.content && noteAppearsBelowField && renderNotes()}
    </FieldWrapper>
  );
};

FieldFile.propTypes = {
  data: PropTypes.shape({
    ref: PropTypes.object,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.string,
    required: PropTypes.bool,
    note: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    onChange: PropTypes.func.isRequired,
    noteAppearsBelowField: PropTypes.bool.isRequired
  }).isRequired
};

export default FieldFile;
